import React from 'react';
import PropTypes from 'prop-types';
import MuiTableHead from '@material-ui/core/TableHead';
import TableRow from './TableRow';
import TableHeadCell from './TableHeadCell';
import TableActionHeadCell from './TableActionHeadCell';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  root: {},
});

class TableHead extends React.Component {
  static propTypes = {
    /** Styles to be applied to component */
    classes: PropTypes.object,
    /**
     * Read Only mode will force table to ignore renderComponent per columns and display cell value.
     * It will also make rows not selectable.
     */
    readOnly: PropTypes.bool.isRequired,
    /** Column id from which table is sorted by */
    sortedBy: PropTypes.string,
    /** Developer styles overrides */
    styleOverrides: PropTypes.object.isRequired,
    /** Populate first column with selectable radio button */
    selectableRows: PropTypes.bool.isRequired,
    /** Callback function for sort changes */
    onChangeSort: PropTypes.func,
    tableHeadCellProps: PropTypes.object,
  };

  render() {
    const {
      columns,
      selectableRows,
      actionable,
      onChangeSort,
      styleOverrides,
      readOnly,
      hideHeader,
      sortedBy,
      tableHeadCellProps = {},
    } = this.props;
    const totalColumns = columns.length;

    if (hideHeader) return null;

    return (
      <MuiTableHead>
        <TableRow rowType={'head'}>
          {(actionable || selectableRows) && !readOnly ? (
            <TableActionHeadCell selectableRows={selectableRows} actionable={actionable} />
          ) : null}
          {columns.map((col, colIndex) =>
            col.visible ? (
              <TableHeadCell
                styleOverrides={{ TableHeadCell: styleOverrides.TableHeadCell }}
                onChangeSort={onChangeSort}
                key={colIndex}
                colIndex={colIndex}
                colData={col}
                isSortedByCol={col.id === sortedBy}
                totalColumns={totalColumns}
                tableHeadCellProps={tableHeadCellProps}
              />
            ) : null,
          )}
        </TableRow>
      </MuiTableHead>
    );
  }
}

export default styled(TableHead)(styles);
